import * as React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import appConfig from 'application-config';
import _ from 'lodash';

import { Responsive } from 'common/components';
import { ROOT_ROUTE, SHARE_CONSTANTS } from 'client/constants';
import { share, analytics } from 'common/utils';
import {
	FacebookIcon,
	WhatsappIcon,
	MailIcon,
	ShareIcon,
	ContentFacebookIcon,
	ContentWhatsappIcon,
	ContentMailIcon,
	InstaIcon,
} from './svgs';

import * as css from './Socials.scss';

class Socials extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		match: PropTypes.shape({
			path: PropTypes.string.isRequired,
			params: PropTypes.shape({
				categoryId: PropTypes.string,
			}),
		}).isRequired,
		choiceId: PropTypes.string,
		isContentStyles: PropTypes.bool,
		onScreenShotClick: PropTypes.func,
	};

	static defaultProps = {
		className: '',
		choiceId: '',
		isContentStyles: false,
		onScreenShotClick: () => {},
	};

	constructor(props) {
		super(props);

		this.containerRef = React.createRef();

		this.state = {
			isMenuOpen: false,
		};
	}

	onShareBtnClick = () => {
		this.setState(state => ({ isMenuOpen: !state.isMenuOpen }));

		document.addEventListener('click', this.onDocumentClick);
	};

	onDocumentClick = e => {
		if (this.containerRef.current && this.containerRef.current.contains(e.target)) {
			return;
		}

		this.setState({ isMenuOpen: false });
		document.removeEventListener('click', this.onDocumentClick);
	};

	onSocialBtnClick = e => {
		const {
			match: { path },
			choiceId,
		} = this.props;
		const { id: type } = e.currentTarget.dataset;
		const categoryId = 'chart';
		const options = { type, choiceId };
		const domain = _.get(appConfig, ['domains', 'client', 'hostname'], 'NO HOSTNAME');
		const whatsAppImages = {
			main: `${domain}assets/client/share.jpg`,
		};

		if (path !== ROOT_ROUTE) {
			// options.title = 'Result sharing Title';
			options.categoryId = categoryId;
		}

		if (type === SHARE_CONSTANTS.WHATSAPP) {
			options.img = whatsAppImages.main;
		}

		if (choiceId) {
			options.title = `הצבעתי למצעד השנתי של V1 וגלגלצ`;
			options.description = `השירים, האלבומים והאנשים שעשו לי את השנה. אלו הבחירות שלי`;
		}

		share(options, () => {
			if (!this.props.choiceId) {
				analytics.gtag.event(`שיתוף המתחם ${type}`);
			} else {
				analytics.gtag.event(`שיתוף תוצאות ${type}`);
			}
		});
	};

	render() {
		// const {
		// 	className,
		// 	match: { path },
		// } = this.props;
		// const { isMenuOpen } = this.state;
		// const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

		const { className, isContentStyles } = this.props;
		const { isMenuOpen } = this.state;

		// if (Responsive.isMatching(Responsive.MOBILE) && path === CATEGORY_ROUTE) {
		// 	return null;
		// }

		return (
			<div
				className={classNames(
					css.socials,
					isMenuOpen && css.open,
					isContentStyles && css.btnsContentStyles,
					className
				)}
				ref={this.containerRef}
			>
				<Responsive query={Responsive.DESKTOP}>
					<div className={classNames(css.socialBtnWrap, css.facebook)}>
						<button
							data-id={SHARE_CONSTANTS.FACEBOOK}
							onClick={this.onSocialBtnClick}
							className={css.socialBtn}
							type="button"
						>
							{isContentStyles ? <ContentFacebookIcon /> : <FacebookIcon />}
						</button>
					</div>
					<div className={classNames(css.socialBtnWrap, css.whatsapp)}>
						<button
							data-id={SHARE_CONSTANTS.WHATSAPP}
							onClick={this.onSocialBtnClick}
							className={css.socialBtn}
							type="button"
						>
							{isContentStyles ? <ContentWhatsappIcon /> : <WhatsappIcon />}
						</button>
					</div>
					<div className={classNames(css.socialBtnWrap, css.mail)}>
						<button
							data-id={SHARE_CONSTANTS.MAIL}
							onClick={this.onSocialBtnClick}
							className={css.socialBtn}
							type="button"
						>
							{isContentStyles ? <ContentMailIcon /> : <MailIcon />}
						</button>
					</div>
				</Responsive>
				<Responsive query={Responsive.MOBILE}>
					<div className={classNames(css.socialBtnWrap, css.shareBtnWrap)}>
						<button
							className={classNames(css.socialBtn, css.mobileToggleIcon)}
							onClick={this.onShareBtnClick}
							type="button"
						>
							<ShareIcon />
						</button>
					</div>
					<div className={css.shareBtns}>
						<div className={classNames(css.socialBtnWrap, css.facebook)}>
							<button
								data-id={SHARE_CONSTANTS.FACEBOOK}
								onClick={this.onSocialBtnClick}
								className={css.socialBtn}
								type="button"
							>
								{isContentStyles ? (
									<ContentFacebookIcon />
								) : (
									<FacebookIcon className={css.socialBtnLabel} />
								)}
							</button>
						</div>
						<div className={classNames(css.socialBtnWrap, css.whatsapp)}>
							<button
								data-id={SHARE_CONSTANTS.WHATSAPP}
								onClick={this.onSocialBtnClick}
								className={css.socialBtn}
								type="button"
							>
								{isContentStyles ? (
									<ContentWhatsappIcon />
								) : (
									<WhatsappIcon className={css.socialBtnLabel} />
								)}
							</button>
						</div>
						{isContentStyles ? (
							<div className={classNames(css.socialBtnWrap, css.mail)}>
								<button onClick={this.props.onScreenShotClick} className={css.socialBtn} type="button">
									<InstaIcon />
								</button>
							</div>
						) : (
							<div className={classNames(css.socialBtnWrap, css.mail)}>
								<button
									data-id={SHARE_CONSTANTS.MAIL}
									onClick={this.onSocialBtnClick}
									className={css.socialBtn}
									type="button"
								>
									<MailIcon className={css.socialBtnLabel} />
								</button>
							</div>
						)}
					</div>
				</Responsive>
			</div>
		);
	}
}

export default withRouter(Socials);
